import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { LoadingAnimation } from "./LoadingAnimation";
import withTranslator from "../Translator/withTranslation";

const ModalContainer = styled.div`
    z-index:300;
    background: rgba(0,0,0,.7);
`;

const CloseButton = styled.button`
    font-size: 4em;
    line-height: .5em;
`;

const ModalComponent = (props) => {
    const contentRef = React.createRef();
    const modalRef = React.createRef();

    const [modalContent, setModalContent] = useState(null);

    const close = (e) => {

        if (!contentRef.current.contains(e.target)) {
            setModalContent(null);
            if (props.onClose) {
                props.onClose();
            }
        }
    }
    useEffect(() => {
        if (props.loading ) {
            setModalContent(<LoadingAnimation key="modalLoading" color="grey123"/>);
        } else {
            if(props.setHTML){
                setModalContent(<div key="modalContent"  dangerouslySetInnerHTML={{__html: props.content}}/>)
            } else {
                setModalContent(<div key="modalContent">{props.content}</div>);
            }
         }
    },[]);

    useEffect( () => {
        if(props.setHTML){
            setModalContent(<div key="modalContent" dangerouslySetInnerHTML={{__html: props.content}} />);
        } else {
            setModalContent(<div key="modalContent">{props.content}</div>);
        }
    },[]);

    if(!props.content || !modalContent) return (null);
    return (
        <ModalContainer ref={modalRef} key="ModalContainer" className="fixed overflow-scroll-y top-0 left-0 width-100 height-100 p-3 " onClick={ e => close(e)}>
            <CloseButton className="align-self-fend" key="CloseButton" title={props.t('close')} type="button" className="flex bor-no btn-no bg-no white pad-no pointer width-100 justify-fend">&times;</CloseButton>
            <div ref={contentRef} key="content" className="flex flex-column items-center mt-3 children-blue1">
                {modalContent}
            </div>
        </ModalContainer>
    );
}

export const Modal = withTranslator(ModalComponent);